import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";
import { _HttpClient } from "../net/http.client"
@Injectable({
  providedIn: "root"
})
export class DataService {
  constructor(private _http: _HttpClient) { }

  //根据Id|其他 获取相关表信息
  getBusinessTables(url: string, params = {}): Observable<any> {
    return this._http.get(url, params);
  }

  getFormInfo(url: string, params = {}): Observable<any> {
    return this._http.get(url, params);
  }

  //系统控件-人员
  getSysCtrEmployee(params = {}): Observable<any> {
    //let url = "emptable.json";
    let url = this.getWebAPIName("employee");
    let result = this._http.get(url, params);
    return result;
  }

  //系统控件-组织
  getSysCtrOrgTree(params = {}): Observable<any> {
    //let url = "org-tree.json";
    let url = this.getWebAPIName("organization");
    return this._http.get(url, params);
  } 

  //系统控件-职位
  getSysCtrPostionTable(params = {}): Observable<any> {
    //let url = "postiontable.json";
    let url = this.getWebAPIName("postion");
    return this._http.get(url, params);
  }

  //系统控件-地区
  getSysCtrArea(params = {}): Observable<any> {
    let url = "tables.json";

    return this._http.get(url, params);
  }

  //树形数据
  getTreeData(params = {}): Observable<any> {
    //let url = "tree.json";
    let url = this.getWebAPIName("tree");
    return this._http.get(url, params);
  } 

  getWebAPIName(type: string) {
    let result = "";
    let res = localStorage.getItem("KreFORM:WEBAPI");
    if (res != undefined && res != null && res != "") {
      let webapi = JSON.parse(res);
      result = webapi[type];
    }
    if (result == undefined || result == null) {
      result = "";
    }
    return result;
  }
}
